import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { marketplaceProductRequest } from '../../store/marketplace/marketplace-actions';
import { getMarketplaceProductsSelector } from '../../store/marketplace/marketplace-selectors';

import ProductPage from './ProductPage';
import { formatPayload } from '../../utils/format-payload';

import { usePayload, Config, EventsManager } from '@vm/omega-shared-component-webapp';

import { Product } from '../../store/marketplace/types';

export const ProductPageContainer: React.FC = () => {
  const dispatch = useDispatch();
  const { payload, pushPayloadToHistory } = usePayload();
  const { data, ready, error } = useSelector(getMarketplaceProductsSelector);

  const getProductId = useCallback((): string => {
    return formatPayload(payload)?.productId;
  }, [payload]);

  useEffect(() => {
    const productId = getProductId();
    if (!productId) {
      console.error('productids missing from payload');
      pushPayloadToHistory({ ...payload }, Config.get('paths.marketplace.root'));
    }
  }, [getProductId]);

  useEffect(() => {
    const productId = getProductId();
    if (productId) {
      dispatch(marketplaceProductRequest(productId));
    }
  }, [dispatch, getProductId]);

  if (error) {
    EventsManager.systemError.publishCriticalError({ error: error });
  }

  if (ready && !error) {
    return <ProductPage product={data as Product} />;
  }

  return null;
};
